import { createSlice } from '@reduxjs/toolkit';

import {
  addRoofStageOneData,
  addRoofStageThreeData,
  addRoofStageTwoData,
  deleteRoofData,
  deleteRoofStageThreeData,
  deleteRoofStageTwoData,
  fetchRoofFlowHistory,
  fetchRoofList,
  fetchRoofNumbers,
  fetchRoofNumbersForStageTwo,
  fetchroofStageOneForm,
  fetchroofStageThreeForm,
  fetchroofStageTwoForm,
  fetchRoofThreeList,
  fetchRoofTwoList,
  fetchViewRoofStageOne,
  fetchViewRoofStageThree,
  fetchViewRoofStageTwo,
  UpdateRoofFlowStatus,
} from './roofThunk';

const initialState = {
  roof: {
    loading: false,
    success: false,
    error: null,
    stageOneParams: [],
  },
  roofStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  roofStageThree: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  roofList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  roofnumber: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  addRoofStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listRoofStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  addRoofStageThree: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  roofDetails: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  addUpdate: {
    loading: false,
    success: false,
    error: null,
  },
  delete: {
    loading: false,
    success: false,
    error: null,
  },
  roofNumbersForStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  rooftwoList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  roofThreeList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  updateFlowStatus: {
    loading: false,
    success: false,
    error: null,
  },
  roofFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },

  viewStageOne: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  viewStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  viewStageThree: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
};

const roofSlice = createSlice({
  name: 'roof',
  initialState,
  reducers: {
    clearRoofData: (state) => {
      state.roof.stageOneParams = null;
      state.roofStageTwo.stageTwoParams = null;
      state.roofStageThree.stageThreeParams = null;
      state.roofList.data = [];
      state.rooftwoList.data = [];
      state.roofDetails.data = null;
      state.addUpdate.success = false;
      state.delete.success = false;
    },
    clearAddUpdateStatus: (state) => {
      state.addUpdate.success = false;
      state.addUpdate.error = null;
    },
    clearDeleteStatus: (state) => {
      state.delete.success = false;
      state.delete.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchroofStageOneForm.pending, (state) => {
        state.roof.loading = true;
        state.roof.error = null;
      })
      .addCase(fetchroofStageOneForm.fulfilled, (state, action) => {
        state.roof.loading = false;
        state.roof.stageOneParams = action.payload.data;
      })
      .addCase(fetchroofStageOneForm.rejected, (state, action) => {
        state.roof.loading = false;
        state.roof.error = action.payload || 'Failed to fetch params';
      })

      .addCase(fetchroofStageTwoForm.pending, (state) => {
        state.roofStageTwo.loading = true;
        state.roofStageTwo.error = null;
      })
      .addCase(fetchroofStageTwoForm.fulfilled, (state, action) => {
        state.roofStageTwo.loading = false;
        state.roofStageTwo.data = action.payload.data;
      })
      .addCase(fetchroofStageTwoForm.rejected, (state, action) => {
        state.roofStageTwo.loading = false;
        state.roofStageTwo.error = action.payload || 'Failed to fetch params';
      })

      .addCase(addRoofStageTwoData.pending, (state) => {
        state.addRoofStageTwo.loading = true;
        state.addRoofStageTwo.error = null;
      })
      .addCase(addRoofStageTwoData.fulfilled, (state, action) => {
        state.addRoofStageTwo.loading = false;
        state.addRoofStageTwo.data = action.payload.data;
      })
      .addCase(addRoofStageTwoData.rejected, (state, action) => {
        state.addRoofStageTwo.loading = false;
        state.addRoofStageTwo.error = action.payload || 'Failed to fetch params';
      })

      .addCase(addRoofStageThreeData.pending, (state) => {
        state.addRoofStageThree.loading = true;
        state.addRoofStageThree.error = null;
      })
      .addCase(addRoofStageThreeData.fulfilled, (state, action) => {
        state.addRoofStageThree.loading = false;
        state.addRoofStageThree.data = action.payload.data;
      })
      .addCase(addRoofStageThreeData.rejected, (state, action) => {
        state.addRoofStageThree.loading = false;
        state.addRoofStageThree.error = action.payload || 'Failed to fetch params';
      })

      // ==================== ADD/UPDATE STAGE ONE ====================
      .addCase(addRoofStageOneData.pending, (state) => {
        state.addUpdate.loading = true;
        state.addUpdate.error = null;
      })
      .addCase(addRoofStageOneData.fulfilled, (state) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = true;
      })
      .addCase(addRoofStageOneData.rejected, (state, action) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = false;
        state.addUpdate.error = action.payload || 'Failed to add stage one data';
      })

      // ==================== FETCH ROOF LIST ====================
      .addCase(fetchRoofList.pending, (state) => {
        state.roofList.loading = true;
        state.roofList.error = null;
      })
      .addCase(fetchRoofList.fulfilled, (state, action) => {
        state.roofList.loading = false;
        state.roofList.success = true;
        state.roofList.data = action.payload?.data || [];
        state.roofList.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchRoofList.rejected, (state, action) => {
        state.roofList.loading = false;
        state.roofList.success = false;
        state.roofList.error = action.payload || 'Failed to fetch roof list';
      })

      // ==================== DELETE ROOF DATA ====================
      .addCase(deleteRoofData.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteRoofData.fulfilled, (state) => {
        state.delete.loading = false;
        state.delete.success = true;
      })
      .addCase(deleteRoofData.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.success = false;
        state.delete.error = action.payload || 'Failed to delete roof data';
      })
      .addCase(deleteRoofStageTwoData.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRoofStageTwoData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteRoofStageTwoData.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchRoofTwoList.pending, (state) => {
        state.rooftwoList.loading = true;
        state.rooftwoList.error = null;
      })
      .addCase(fetchRoofTwoList.fulfilled, (state, action) => {
        state.rooftwoList.loading = false;
        state.rooftwoList.success = true;
        state.rooftwoList.data = action.payload?.data || [];
        state.rooftwoList.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchRoofTwoList.rejected, (state, action) => {
        state.rooftwoList.loading = false;
        state.rooftwoList.success = false;
        state.rooftwoList.error = action.payload || 'Failed to fetch rooftwo list';
      })
      .addCase(fetchRoofNumbersForStageTwo.pending, (state) => {
        state.roofNumbersForStageTwo.loading = true;
        state.roofNumbersForStageTwo.error = null;
      })
      .addCase(fetchRoofNumbersForStageTwo.fulfilled, (state, action) => {
        state.roofNumbersForStageTwo.loading = false;
        state.roofNumbersForStageTwo.data = action.payload?.data || [];
      })
      .addCase(fetchRoofNumbersForStageTwo.rejected, (state, action) => {
        state.roofNumbersForStageTwo.loading = false;
        state.roofNumbersForStageTwo.error = action.payload || 'Failed to fetch roof numbers';
      })
      // Add to extraReducers
      .addCase(fetchRoofThreeList.pending, (state) => {
        state.roofThreeList.loading = true;
        state.roofThreeList.error = null;
      })
      .addCase(fetchRoofThreeList.fulfilled, (state, action) => {
        state.roofThreeList.loading = false;
        state.roofThreeList.success = true;
        state.roofThreeList.data = action.payload?.data || [];
        state.roofThreeList.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.last_page || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchRoofThreeList.rejected, (state, action) => {
        state.roofThreeList.loading = false;
        state.roofThreeList.success = false;
        state.roofThreeList.error = action.payload || 'Failed to fetch roof three list';
      })

      .addCase(fetchroofStageThreeForm.pending, (state) => {
        state.roofStageThree.loading = true;
        state.roofStageThree.error = null;
      })
      .addCase(fetchroofStageThreeForm.fulfilled, (state, action) => {
        state.roofStageThree.loading = false;
        state.roofStageThree.data = action.payload.data;
      })
      .addCase(fetchroofStageThreeForm.rejected, (state, action) => {
        state.roofStageThree.loading = false;
        state.roofStageThree.error = action.payload || 'Failed to fetch params';
      })
      .addCase(deleteRoofStageThreeData.pending, (state) => {
        state.delete.loading = true;
      })
      .addCase(deleteRoofStageThreeData.fulfilled, (state) => {
        state.delete.loading = false;
        state.delete.success = true;
      })
      .addCase(deleteRoofStageThreeData.rejected, (state) => {
        state.delete.loading = false;
        state.delete.success = false;
      })

      .addCase(UpdateRoofFlowStatus.pending, (state) => {
        state.updateFlowStatus = {
          loading: true,
          error: null,
        };
      })
      .addCase(UpdateRoofFlowStatus.fulfilled, (state) => {
        state.updateFlowStatus = {
          loading: false,
          success: true,
          error: null,
        };
      })
      .addCase(UpdateRoofFlowStatus.rejected, (state, action) => {
        state.updateFlowStatus = {
          loading: false,
          success: false,
          error: action.payload || 'Failed to update flow status',
        };
      })
      .addCase(fetchRoofFlowHistory.pending, (state) => {
        state.roofFlowHistory.loading = true;
        state.roofFlowHistory.error = null;
      })
      .addCase(fetchRoofFlowHistory.fulfilled, (state, action) => {
        state.roofFlowHistory.loading = false;
        state.roofFlowHistory.success = true;
        state.roofFlowHistory.data = action.payload.data;
      })
      .addCase(fetchRoofFlowHistory.rejected, (state, action) => {
        state.roofFlowHistory.loading = false;
        state.roofFlowHistory.success = false;
        state.roofFlowHistory.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(fetchViewRoofStageOne.pending, (state) => {
        state.viewStageOne.loading = true;
        state.viewStageOne.error = null;
      })
      .addCase(fetchViewRoofStageOne.fulfilled, (state, action) => {
        state.viewStageOne.loading = false;
        state.viewStageOne.success = true;
        state.viewStageOne.data = action.payload.data;
      })
      .addCase(fetchViewRoofStageOne.rejected, (state, action) => {
        state.viewStageOne.loading = false;
        state.viewStageOne.success = false;
        state.viewStageOne.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(fetchViewRoofStageTwo.pending, (state) => {
        state.viewStageTwo.loading = true;
        state.viewStageTwo.error = null;
      })
      .addCase(fetchViewRoofStageTwo.fulfilled, (state, action) => {
        state.viewStageTwo.loading = false;
        state.viewStageTwo.success = true;
        state.viewStageTwo.data = action.payload.data;
      })
      .addCase(fetchViewRoofStageTwo.rejected, (state, action) => {
        state.viewStageTwo.loading = false;
        state.viewStageTwo.success = false;
        state.viewStageTwo.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(fetchViewRoofStageThree.pending, (state) => {
        state.viewStageThree.loading = true;
        state.viewStageThree.error = null;
      })
      .addCase(fetchViewRoofStageThree.fulfilled, (state, action) => {
        state.viewStageThree.loading = false;
        state.viewStageThree.success = true;
        state.viewStageThree.data = action.payload.data;
      })
      .addCase(fetchViewRoofStageThree.rejected, (state, action) => {
        state.viewStageThree.loading = false;
        state.viewStageThree.success = false;
        state.viewStageThree.error = action.payload || 'Failed to fetch flow history';
      })
       .addCase(fetchRoofNumbers.pending, (state) => {
        state.roofnumber.loading = true;
        state.roofnumber.error = null;
      })
      .addCase(fetchRoofNumbers.fulfilled, (state, action) => {
        state.roofnumber.loading = false;
        state.roofnumber.success = true;
        state.roofnumber.data = action.payload?.data || [];
      })
      .addCase(fetchRoofNumbers.rejected, (state, action) => {
        state.roofnumber.loading = false;
        state.roofnumber.success = false;
        state.roofnumber.error = action.payload || 'Failed to fetch roof list';
      })

  },
});

export default roofSlice.reducer;
